import { ArrowRight } from "lucide-react";

const STEPS = [
  {
    number: "01",
    title: "Describe your offer",
    description:
      "Five fields — name, audience, promise, niche, price. We pull the right offer template before you finish typing.",
  },
  {
    number: "02",
    title: "Customize visually",
    description:
      "Drag, swap, recolor, restyle. Every section is a tuned block — no design skills required, no AI glitches.",
  },
  {
    number: "03",
    title: "Publish · capture · convert",
    description:
      "One click puts you live at your-name.funnlr.co. Built-in analytics show exactly what's converting.",
  },
];

export function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="bg-white px-6 py-20 sm:py-28"
    >
      <div className="mx-auto max-w-6xl">
        <div className="max-w-2xl">
          <p
            data-reveal
            className="text-[11px] font-semibold uppercase tracking-[0.18em] text-violet-600"
          >
            How it works
          </p>
          <h2
            data-reveal
            className="mt-4 font-heading text-[32px] font-bold leading-[1.05] tracking-tight text-slate-900 sm:text-[44px]"
          >
            From blank page to live funnel —
            <br className="hidden sm:block" />
            <span className="text-gradient-brand">
              {" "}
              in three deliberate steps.
            </span>
          </h2>
        </div>

        <div
          data-reveal-stagger
          className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl bg-slate-100 ring-1 ring-slate-100 sm:grid-cols-3"
        >
          {STEPS.map((step, i) => (
            <div
              key={step.number}
              className="relative flex flex-col gap-3 bg-white p-7 sm:p-8"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-[11px] font-bold tracking-[0.18em] text-violet-600">
                  {step.number}
                </span>
                {i < STEPS.length - 1 && (
                  <ArrowRight className="hidden h-3.5 w-3.5 text-slate-300 sm:block" />
                )}
              </div>
              <h3 className="font-heading text-lg font-bold tracking-tight text-slate-900">
                {step.title}
              </h3>
              <p className="text-[14px] leading-relaxed text-slate-500">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
